import React from 'react';
import ReactDOM from 'react-dom';
import {Link} from 'react-router';
import LoginModal from '../components/LoginModal';
import SignupModal from '../components/SignupModal';
import $ from 'jquery';
import 'bootstrap/dist/js/bootstrap';

// import 'jquery';
// import 'bootstrap/dist/js/bootstrap';

var HomeHeader = React.createClass({


	getInitialState: function () {
	 return {
	 	showLogin: false,
	 	showSignup: false,
	 };
	},
	handleOpenLogin:function(){
	  this.setState({showLogin: true});
	},
	handleCloseLogin:function(){
	  this.setState({showLogin: false});
	},

	handleOpenSignup:function(){
	  this.setState({showSignup: true});
	},
	handleCloseSignup:function(){
	  this.setState({showSignup: false});
	},

	getOffset:function(element){
	  var bounding = element.getBoundingClientRect();
	  return {
	      top: bounding.top + document.body.scrollTop,
	      left: bounding.left + document.body.scrollLeft
	    };
	},

	toggleCollapse:function(){
		const navbar_inner = ReactDOM.findDOMNode(this.refs.navbar_inner);
		const navbar = ReactDOM.findDOMNode(this.refs.navbar);


		if(navbar_inner.classList.contains("in")){
		 	$('#navbar_inner').collapse('hide');
		 	setTimeout(function(){
		 		navbar.classList.remove("collapse_background");
		 	},310)

		}else{
			navbar.classList.add("collapse_background");
			$('#navbar_inner').collapse('show')
			// $('#navbar_inner').css('border', '3px solid red')
		}
	},

	handleScroll:function(){
	   const navbar = ReactDOM.findDOMNode(this.refs.navbar);
	   // startElement = React.findDOMNode(this.refs.sec2);
	   const offset = 0;//this.getOffset(startElement)
	   const windowsScrollTop  = window.pageYOffset;
	   if(windowsScrollTop == offset){
	     navbar.classList.remove("color_background");
	   }else{
	     navbar.classList.add("color_background");
	   }
	},

	componentDidMount:function() {
		if(!this.props.stayOpaque){
			const navbar = ReactDOM.findDOMNode(this.refs.navbar);
			navbar.classList.remove("color_background");
	    	window.addEventListener('scroll', this.handleScroll);
		}

	},

	componentWillUnmount:function() {
		if(!this.props.stayOpaque){

			const navbar = ReactDOM.findDOMNode(this.refs.navbar);
			navbar.classList.remove("color_background");
			window.removeEventListener('scroll', this.handleScroll);
		}
	},

	render:function(){
		const logoUrl = undefined == this.props.logo ? require('../../img/logo-basic.png') : this.props.logo
		const fontColor = undefined == this.props.fontColor ? '#fff' : this.props.fontColor
		// console.log("lalalala ", this.props.style)
	    return (

	    	<span >
		    	<div style={this.props.style} ref="navbar" className="navbar transparent navbar-inverse navbar-static header_main navbar-fixed-top">
		    		<div className="container">
		    			<div className="navbar-inner">
							<div className="navbar-header">

							    <a className="navbar-brand" href="#">
							    	<div className="logo_wrap">
							    		<img src={logoUrl} alt="logo"/>
							    	</div>
							    </a>
							  	{/*<a aria-controls="navbar" aria-expanded="false" onTouchTap={this.toggleCollapse.bind(this)} className="hidden-bg hidden-md hidden-sm navbar-toggle collapsed tipigo-toggle" type="button">
							        <span className="sr-only">Toggle navigation</span>
							        <span className="icon-bar"></span>
							        <span className="icon-bar"></span>
							        <span className="icon-bar"></span>
							    </a>*/}
							</div>

							<ul id="navbar_inner" ref="navbar_inner" className="nav navbar-nav navbar-right collapse navbar-collapse">

								<li className="margin_right_10 hidden-xs">
									{this.props.hideLogin ? null : <a onTouchTap={this.handleOpenLogin} >LOGIN</a>}
								</li>
								<li className="margin_right_10">
									<Link style={{color:fontColor}} to="contact_us">CONTACT US</Link>
								</li>


								{/* <a onTouchTap={this.handleOpenSignup} className="btn btn-success btn-raised navbar-btn tipigo_signup_btn margin_right_10" to="signup">SIGN UP</a> */}
							 </ul>

						</div>
					</div>
				</div>
				<LoginModal handleClose={this.handleCloseLogin} open={this.state.showLogin}></LoginModal>
				<SignupModal handleClose={this.handleCloseSignup} open={this.state.showSignup}></SignupModal>
			</span>

    	);
	}
});
export default HomeHeader;



// WEBPACK FOOTER //
// ./src/js/components/HomeHeader.js